<div class="modal-body">
  <div class="modal-header-wrapper">
    <h2 class="title-text">{{title}}</h2>
  </div>
  <div id="modal-content-wrapper">
    <ckeditor [(ngModel)]="content" [config]="config" [editor]="Editor" class="msd-content"></ckeditor>
  </div>
  <div *ngIf="withName" class="form-field">
    <label>Nom du document</label>
    <input type="text" [(ngModel)]="name" [class.is-invalid]="isInvalidName()" class="form-control" placeholder="Nom du document">
  </div>
</div>
<div class="modal-footer">
  <button (click)="hideModal()"
          class="btn btn-outline-primary btn-outline text-only"
          id="cancel-button"
          type="button">
    Annuler
  </button>
  <button (click)="validation()"
          [disabled]="!enabledValidation()"
          class="btn btn-primary btn-gradient"
          id="validate-button"
          type="button">
    Valider
  </button>
</div>
